import { Link } from 'react-router-dom';

import { DefaultTooltip } from 'twyne-new.ui';

import { getInfo, keyOf } from '@Components/Grid/components/Table/formatters';

export default function EntityTipFormatter({ info }) {
  const { row } = getInfo(info)
  const id = keyOf(info, 'entity')

  const { entity_id, entity, content_type } = row

  if (entity_id) {
    return <div>
      <Link
        id={id}
        to={`/cms/${content_type}/${entity === 'tag' ? `tags/${entity_id}` : entity_id}`}
        className="text-secondary btn-link"
      >
        <DefaultTooltip placement="right" content={`ID: ${entity_id}`}>
          <span>{EntityFormatter[entity]}</span>
        </DefaultTooltip>
      </Link>
    </div>
  }

  return <div>
    <DefaultTooltip placement="right" content={`ID: ${entity_id}`}>
      <span id={id} >{EntityFormatter[entity]}</span>
    </DefaultTooltip>
  </div>
}

const EntityFormatter = {
  post: 'Post',
  tag: 'Tag',
  root_file: 'Root File',
}
